/* eslint-disable */
/* tslint:disable */
import React from 'react';
export default (function (_a) {
    var style = _a.style;
    return (React.createElement("svg", { className: "slideshow-arrow", style: style, width: "39px", height: "11px", viewBox: "0 0 39 11", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        React.createElement("g", { stroke: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("g", { transform: "translate(-29.000000, -43.000000)", fillRule: "nonzero" },
                React.createElement("polygon", { points: "59.79296 43 67.1767272 48.2074587 59.79296 53.3482492 59.792 49.24 29 49.2402303 29 47.3156703 59.792 47.315" })))));
});
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=arrow4.js.map